
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-events/make-a-request",
      function () {
        return require("private-next-pages/private-events/make-a-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-events/make-a-request"])
      });
    }
  